/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type BeginBindingRefreshRequestBody = {
  bindingId: string;
  principalId: string;
  userSessionIssuerId: string;
};

/** @internal */
export type BeginBindingRefreshRequestBody$Outbound = {
  binding_id: string;
  principal_id: string;
  user_session_issuer_id: string;
};

/** @internal */
export const BeginBindingRefreshRequestBody$outboundSchema: z.ZodMiniType<
  BeginBindingRefreshRequestBody$Outbound,
  BeginBindingRefreshRequestBody
> = z.pipe(
  z.object({
    bindingId: z.string(),
    principalId: z.string(),
    userSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      bindingId: "binding_id",
      principalId: "principal_id",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function beginBindingRefreshRequestBodyToJSON(
  beginBindingRefreshRequestBody: BeginBindingRefreshRequestBody,
): string {
  return JSON.stringify(
    BeginBindingRefreshRequestBody$outboundSchema.parse(
      beginBindingRefreshRequestBody,
    ),
  );
}
